module KendoWidgets
{
	export class MaskedTextBoxOptions implements kendo.ui.MaskedTextBoxOptions
	{
		name?: string;
		clearPromptChar?: boolean;
		culture?: string;
		mask?: string;
		promptChar?: string;
		rules?: any;
		unmaskOnPost?: boolean;
		value?: string;

		label?: string;
		labelPosition?: LabelPositionEnum;
		labelClass?: string;
		labelWidth?: number;

		width?: string | number;
		height?: string | number;
		textAlign?: TextAlignEnum;

		change?(e: kendo.ui.MaskedTextBoxChangeEvent): void;
	}

	export class MaskedTextBox extends kendo.ui.MaskedTextBox implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.MaskedTextBox; }
		private _firstLoad: boolean;
		private _isEnabled: boolean;

		constructor(element: Element, options?: KendoWidgets.MaskedTextBoxOptions)
		{
			if (options == null)
				options = new KendoWidgets.MaskedTextBoxOptions();

			if (options.width == null) options.width = 190;
			if (options.textAlign == null) options.textAlign = TextAlignEnum.Left;

			//#region Width and Height
			if (typeof (options.width) == "number")
				options.width = options.width + "px";
			(element as HTMLElement).style.cssText += "width: " + options.width;

			if (typeof (options.height) == "number")
				options.height = options.height + "px";
			(element as HTMLElement).style.cssText += "height: " + options.height;
			//#endregion

			super(element, options);
			let that = this;

			//#region Label
			if (options.label != null && !this._firstLoad)
			{
				this._firstLoad = true;

				$("#" + element.id + "Label").remove();
				let label = document.createElement("label");
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						class: options.labelClass,
						height: 19,
						fontSize: 14,
						width: (options.labelWidth != null) ? options.labelWidth : "auto"
					});

				//#region Label position
				if (options.labelPosition == null) options.labelPosition = LabelPositionEnum.Top;
				switch (options.labelPosition)
				{
					case LabelPositionEnum.Top:
						{
							$(label).addClass("k-label-top");
							element.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.insertBefore(label, element!.parentElement!.firstChild);

							(element as HTMLElement).style.cssText += "width: 100%";
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");
							element.parentElement!.insertBefore(label, element!.parentElement!.firstChild);
							label.style.cssText += "margin-right: 5px";

							if (options.width == "100%")
								(element as HTMLElement).style.cssText += "width: Calc(100% - " + (label.clientWidth + 5) + "px)";
							else
								(element as HTMLElement).style.cssText += "width: " + (options.width.getNumericPart() + label.clientWidth + 5) + "px !important;";
						}
						break;
					case LabelPositionEnum.Right:
						{
							$(label).addClass("k-label-right");
							element.parentElement!.append(label);
							label.style.cssText += "margin-left: 5px";

							if (options.width == "100%")
								(element as HTMLElement).style.cssText += "width: Calc(100% - " + (label.clientWidth + 5) + "px)";
							else
								(element as HTMLElement).style.cssText += "width: " + (options.width.getNumericPart() + label.clientWidth + 5) + "px !important;";
						}
						break;
					case LabelPositionEnum.Bottom:
						{
							$(label).addClass("k-label-bottom");
							element.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.append(label);

							(element as HTMLElement).style.cssText += "width: 100%";
						}
						break;
				}
				//#endregion

				(element.parentElement! as HTMLElement).style.cssText += "width: " + options.width;
				$(element).parent().attr("id", element.id + "Parent");
			}
			//#endregion

			//#region Text align
			switch (options.textAlign)
			{
				case TextAlignEnum.Left: $(element).css("text-align", "left"); break;
				case TextAlignEnum.Center: $(element).css("text-align", "center"); break;
				case TextAlignEnum.Right: $(element).css("text-align", "right"); break;
			}
			//#endregion
		}

		enabled(value?: boolean)
		{
			if (value != null)
			{
				(this.element[0] as HTMLInputElement).disabled = !value;
				this._isEnabled = value;
			}

			return this._isEnabled;
		}

		visible(visibleStatus?: boolean)
		{
			if (visibleStatus != null)
			{
				if (visibleStatus)
					this.element.parent().parent().show();
				else
					this.element.parent().parent().hide();
			}

			return this.element.is(":visible");
		}

		clear()
		{
			this.value("");
		}

		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().prependTo(element);
		}

		mask(mask: string)
		{
			this.setOptions({ mask: mask });
		}
	}

	MaskedTextBox.fn = MaskedTextBox.prototype;
	MaskedTextBox.fn.options = $.extend(true, {}, kendo.ui.MaskedTextBox.fn.options);
	MaskedTextBox.fn.options.name = "MaskedTextBox";
	kendo.ui.plugin(MaskedTextBox);
}

interface JQuery
{
	kendoMaskedTextBox(options?: KendoWidgets.MaskedTextBoxOptions): JQuery;
}